import { routingNumberValidator } from "field-frames/src/utils/routing-number-utils";

export const isValidRoutingNumber =
  () =>
  (value: string): boolean => {
    return routingNumberValidator(value);
  };
